export default {
	limited(str, len) {
		if(!str || str.length <= len) {
			return str
		}
		
		return str.slice(0, len) + ' ...';
	}
}



// WEBPACK FOOTER //
// ./src/js/string.js